import { useScreenCounter } from '../../hooks/useScreenCounter';

export const NavigationCounterWrapper = ({
  resetNavigation,
  isBackgroundVisible,
  inAutoNavigate,
  rtl,
}: {
  resetNavigation: () => void;
  isBackgroundVisible: boolean;
  inAutoNavigate: boolean;
  rtl: boolean;
}) => {
  useScreenCounter({ resetNavigation, rtl, isBackgroundVisible, inAutoNavigate });

  return <></>;
};
